<script lang="ts">
	import Account from './Account.svelte'

	interface Props {
		tiktok?: string | null
		instagram?: string | null
		youtube?: string | null
		rss?: string | null
		isImmutable?: boolean
		onupdateSocialUsername?: (platform: string, username: string) => void
	}

	let {
		tiktok = null,
		instagram = null,
		youtube = null,
		rss = null,
		isImmutable = true,
		onupdateSocialUsername,
	}: Props = $props()

	let filteredAccounts = $derived(
		[
			{ platform: 'instagram', username: instagram },
			{ platform: 'tiktok', username: tiktok },
			// { platform: 'youtube', username: youtube },
			// { platform: 'rss', username: rss },
		].filter((account) =>
			isImmutable
				? account.username !== null &&
					account.username !== '' &&
					account.username !== 'not set' &&
					account.username !== 'Add a Name'
				: true,
		),
	)

	function checkIfHasSocials() {
		if (instagram?.length > 0 || tiktok?.length > 0) {
			return true
		}
		return false
	}

	const platformIcons = {
		tiktok: '/visuals/icons/social/tiktok-logo.svg',
		instagram: '/visuals/icons/social/instagram-logo.svg',
		youtube: '/visuals/icons/social/youtube-logo.svg',
		rss: '/visuals/icons/social/rss-simple.svg',
	}
</script>

{#if checkIfHasSocials() || !isImmutable}
	<div class="flex flex-col items-start space-y-1 mt-3 pb-4 w-full">
		<p class="text-xs text-brand-gray-4 pb-2">Social Accounts</p>
		<div class="grid grid-rows-2 grid-flow-col gap-x-4 gap-y-3 w-full">
			{#each filteredAccounts as account}
				<Account
					platformIcon={platformIcons[account.platform]}
					username={account.username}
					platform={account.platform}
					{isImmutable}
					{onupdateSocialUsername}
				/>
			{/each}
		</div>
	</div>
{/if}
